import {combineReducers} from 'redux';
import authenticationObjReducer from "./authentication.reducer";
import configObjReducer from "./config.reducer";
import navigationReducer from "./navigation.reducer";
import keywordsReducer from './KeywordSlice';
import itemsReducer from './ItemsSlice';
import labSettingsReducer from './LabSettingsSlice';

let rootReducer = combineReducers({
    authenticationObj:authenticationObjReducer,
    configObj: configObjReducer,
    dirtyObj: navigationReducer,
    keywordObj: keywordsReducer,
    itemsObj: itemsReducer,
    labSettingsObj: labSettingsReducer
});

// Export the RootState type - this represents the entire Redux store state
export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
